var exports = {
  "kL": "container__7D6xWT",
  "EO": "container_inlineAvatars__txRyN3",
  "wx": "header__91132F",
  "qd": "headerTitle__gk_AHb",
  "DD": "title__aM_QXd",
  "$s": "headerActions__hLaeWt",
  "Nx": "previewLink__eeMuga",
  "Ip": "chips__jroRjH",
  "jw": "chip__EiSjiI",
  "u_": "chipApplied__hLf-fM",
  "OV": "chipWrapper__J1-sEd",
  "Jh": "chipButton__mvqBN8",
  "Q$": "chipRejecting__mBwiyG",
  "WD": "chipFieldName__fSyq11",
  "iY": "chipArrow__JDCQ7n",
  "ET": "chipValue__18giGU",
  "j6": "chipValueGroup__LTBaDp",
  "D_": "chipValueSeparator__vU-pmi",
  "GQ": "chipValueInner__eLk9YX",
  "KF": "chipDot__phBUyB",
  "EE": "chipAvatar__zZxMhh",
  "fU": "chipValueText__ABL_qI",
  "Fw": "chipCheck__O_oda2",
  "qi": "chipCloseIconDone__JDpcdA",
  "vi": "chipCloseIconMuted__nVEJ_w",
  "WK": "chipCloseIconOpen__NIAuTz",
  "r2": "duplicateTarget__EQBV9n",
  "$u": "duplicateTargetTitle__JZxWQO",
  "yF": "divider__nXNu6J",
  "oC": "rationaleOverlay__5vAndf",
  "Pd": "confidenceLabel__qwWY1s",
  "XU": "authorHeader__AECxZl",
  "Du": "authorAvatar__bNAETN",
  "fh": "authorName__vylCux",
  "OZ": "authorTimestamp__okyVL0",
  "mH": "rationaleBody__59mdTM",
  "g2": "rationaleList__Dm4v0L",
  "_e": "rationaleListLabel__rp5AJf",
  "Nw": "rationaleActions__56i2RG",
};

module.exports = exports;
